import CityPage from "../CityPage";

export default function Bartlett() {
  return <CityPage slug="bartlett" />;
}
